
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/playgame",
      function () {
        return require("private-next-pages/playgame.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/playgame"])
      });
    }
  